import React, { useEffect, useRef, useState } from "react";
import "../css/layout.css";
import css from "../css/Profile.module.css";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import Rightcontainer from "../Components/Rightcontainer";
import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "../css/kyc.css";
import "../css/Loader.css";
import { IoIosCall } from "react-icons/io";
import { HiOutlineMail } from "react-icons/hi";
import { IoIosLogOut } from "react-icons/io";
import findGif from "../css/loading_old.gif";
import { apiRequest } from "../store/allApi";

const Profile1 = ({ profile1 }) => {
  // BASE URL

  // const beckendLocalApiUrl = process.env.REACT_APP_API_BASE_URL;
  // const beckendLiveApiUrl = process.env.REACT_APP_API_BASE_URL;
  // const nodeMode = process.env.NODE_ENV;
  // if (nodeMode === "development") {
  //   var baseUrl = beckendLocalApiUrl;
  // } else {
  //   baseUrl = beckendLiveApiUrl;
  // }

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  // alert(baseUrl)
  // +++++++++++++++++++++++++++++
  const [show, setShow] = useState(false);

  const [show1, setShow1] = useState(false);

  const handleClose = () => setShow1(false);
  const handleShow = () => {
    setShow1(true);
  };

  const [referral, setCode] = useState(null);
  const [Id, setId] = useState(null);

  const [profile, setProfile] = useState();
  const [portcss, setPortcss] = useState(css.active_tab);
  const [portcss1, setPortcss1] = useState(css.inactive_tab);
  const [crushcss, setCrushcss] = useState(true);
  const [holder_name, setHolder_name] = useState();
  const [account_number, setAccount_number] = useState();
  const [ifsc_code, setIfsc_code] = useState();
  const [upi_id, setUpi_id] = useState();
  const [isLoading, setIsloading] = useState(false);

  // KYC MODEL

  const [showKyc, setShowKyc] = useState(false);
  const [showBottom, setShowBottom] = useState(false);
  const [process1, setProcesss] = useState(false);

  const handleCloseBottom = () => setShowBottom(false);
  const handleShowBottom = (data) => {
    setShowBottom(true);
  };
  const handleCloseKyc = () => {
    setShowKyc(false);
    window.location.reload();
  };
  const handleShowKyc = () => setShowKyc(true);
  const [inputOpen, setInputOpen] = useState(false);
  const [Email, setEmail] = useState();

  const toggleInput = () => {
    setInputOpen(!inputOpen);
  };

  const history = useHistory();

  const meeApi = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`me`, "GET", null, headers);
      if (res.data) {
        setProfile(res.data);
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        history.push("/login");
      }
    } finally {
    }
  };
  useEffect(() => {
    meeApi();
  }, []);

  const logout = async () => {
    localStorage.clear();

    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`me`, "GET", null, headers);
      if (res.data) {
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        history.push("/login");
      }
    } finally {
    }
  };

  //Update email

  const UpdateEmail = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (Email != null) {
      axios
        .patch(baseUrl + `/user/profile/edit`, { Email }, { headers })
        .then((res) => {
          meeApi();
          if (res.data.status == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "error",
              confirmButtonText: "OK",
            });
          } else {
            setEmail(res.data);
            setInputOpen(false);
            Swal.fire({
              title: res.data.msg,
              icon: "Success",
              confirmButtonText: "OK",
            });
            // UserALL();
          }
        })
        .catch((e) => {
          // setLoading(false)
        });
    } else {
      Swal.fire({
        title: "Please enter your Email",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // name Update

  const [Name, setName] = useState();

  const handleNameChange = (e) => {
    const enteredName = e.target.value;

    if (enteredName.length <= 10) {
      setName(enteredName);
    } else {
      Swal.fire({
        title: "Name lessthen 10 characters)",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // siteSetting
  const [msg, setMsg] = useState("");

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const UpdateProfile = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (Name != null) {
      axios
        .patch(baseUrl + `/user/profile/edit`, { Name }, { headers })
        .then((res) => {
          // meeApi();
          if (res.data.status == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "error",
              confirmButtonText: "OK",
            });
          } else {
            setEmail(res.data);
            setInputOpen(false);
            Swal.fire({
              title: res.data.msg,
              icon: "Success",
              confirmButtonText: "OK",
            });
            // UserALL();
          }
        })
        .catch((e) => {
          // setLoading(false)
        });
    } else {
      Swal.fire({
        title: "Please enter your Name",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const update_RefCode = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (referral != null) {
      const data = await axios
        .patch(
          baseUrl + `/user/profile/edit`,
          {
            referral,
          },
          { headers }
        )
        .then((res) => {
          console.log(res);
          if (res.data.submit == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "error",
              confirmButtonText: "OK",
            });
          } else {
            Swal.fire({
              title: res.data.msg,
              icon: "success",
              confirmButtonText: "OK",
            });
          }
        });
    } else {
      Swal.fire({
        title: "Invalid referral code",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  //// total game
  const [total, setTotal] = useState();
  const TotalGame = async (Id) => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `total/user/all/${userId}`,
        "GET",
        null,
        headers
      );
      if (res.data) {
        setTotal(res.data);
      }
    } catch (e) {
      // setLoading(false)
    } finally {
    }
  };

  const [pic, setPic] = useState();
  const Result = async (file) => {
    if (file) {
      const access_token = localStorage.getItem("token");

      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const formData = new FormData();
      formData.append("avatar", file);

      try {
        const res = await apiRequest(
          `users/me/avatar`,
          "POST",
          formData,
          headers
        );
        if (res.data) {
        }
      } catch (e) {
        // setLoading(false)
      } finally {
      }
    }
  };
  //avatar

  const Kyc = async () => {
    setShowKyc(true);
    const inputOptions = new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          "Auto Kyc": "Auto Kyc",
          "Complete Kyc": "Complete Kyc",
        });
      }, 1000);
    });
  };

  // AADHAR API

  const [AadharNum, setAadharNum] = useState("");
  const [userAdharData, setUserAdharData] = useState("");
  // const handleAdharChnage = (e) => {
  //   setAadharNum(e.target.value);
  // };
  const handleAdharChnage = (e) => {
    const inputValue = e.target.value;

    if (/^[0-9]*$/.test(inputValue) || inputValue === "") {
      if (inputValue.length <= 12) {
        setAadharNum(inputValue);
      }
    }
  };
  const AdharNumber = async (e) => {
    setIsloading(true);
    e.preventDefault();

    // Ensure AadharNum is a 12-digit number before making the API call
    if (/^[0-9]{12}$/.test(AadharNum)) {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const data = {
        aadharNumber: AadharNum,
      };

      try {
        const res = await apiRequest(`aadharcard-auto`, "POST", data, headers);
        if (res.data) {
          console.log(res?.data?.data?.data?.message);
          setUserAdharData(res?.data);
          setIsloading(false);

          if (res.data.status === false) {
            setMsg(res?.data?.msg);
          } else {
            setMsg(res?.data?.data?.message);
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Invalid Aadhar Number",
        text: "Please enter a valid 12-digit Aadhar number.",
      });
      setIsloading(false);
    }
  };

  const [AadharOtp, setAadharOtp] = useState("");
  const [verifyData, setVerifyData] = useState("");
  const [kycdata, setKycdata] = useState();
  const [isLoading1, setIsloading1] = useState(false);

  const handleAdharOtpChnage = (e) => {
    setAadharOtp(e.target.value);
  };

  const AdharOtp = async (e) => {
    setIsloading1(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const data = {
      aadharNumber: AadharNum,
      otp: AadharOtp,
      Email: Email,
      transaction_id: userAdharData.data?.request_id,
    };

    try {
      const res = await apiRequest(
        `aadharcard-auto-verify`,
        "POST",
        data,
        headers
      );
      if (res.data) {
        setKycdata(res.data);
        setVerifyData(res.data);
        setIsloading1(false);

        if (res.data.status === false) {
          setMsg(res.data?.msg);
        } else {
          window.location.reload();
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
    }
  };

  // DOCUMENTATION API START

  let aadharProcess = useRef(false);

  const [Names, setNames] = useState("");
  const [DOB, setDob] = useState("");
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);

  const handleSubmitdata = async (e) => {
    e.preventDefault();
    // console.log(aadharProcess, "ghh")
    if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
      alert("Please fill in all fields and upload both images.");
      return;
    }

    if (aadharProcess.current === false) {
      setProcesss(true);
      aadharProcess.current = true;

      const formData = new FormData();
      formData.append("Name", Names);
      formData.append("DOB", DOB);
      formData.append("front", frontLoaded[0]);
      formData.append("back", backLoaded[0]);
      formData.append("Number", AadharNum);
      formData.append("Email", Email);

      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      try {
        const res = await apiRequest(`aadharcard`, "POST", formData, headers);
        if (res.data) {
          if (res.data.status === false) {
            Swal.fire({
              title: res.data.msg,
              icon: "error",
              confirmButtonText: "OK",
            }).then((result) => {
              if (result.isConfirmed) {
                handleCloseKyc();
              }
            });
          } else if (res.data.msg === "Duplicate Entity") {
            Swal.fire({
              title: "Duplicate Entity",
              icon: "error",
              confirmButtonText: "OK",
            }).then((result) => {
              if (result.isConfirmed) {
                handleCloseKyc();
              }
            });
          } else {
            Swal.fire({
              title: "Your KYC form submitted",
              icon: "success",
              confirmButtonText: "OK",
            }).then((result) => {
              if (result.isConfirmed) {
                handleCloseKyc();
              }
            });
            history.push("/Profile");
          }

          aadharProcess.current = false;
          setProcesss(false);
        }
      } catch (error) {
        console.error(error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem("token");
          window.location.reload();
          history.push("/login");
        }
      } finally {
      }
    } else {
      alert("You have submitted a request already.");
    }
  };

  useEffect(() => {
    // UserALL();
    TotalGame();
  }, []);

  // Email validations
  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);

    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const isValidFormat = emailRegex.test(newEmail);

    const endsWithCom = newEmail.toLowerCase().endsWith(".com");

    setIsValidEmail(isValidFormat && endsWithCom);
  };

  return (
    <>
      {/* <Header user={profile} /> */}
      {
        <div
          className="leftContainer mb_space"
          style={{
            minHeight: "100vh",
            paddingTop: "80px",
            paddingBottom: "60px",
          }}
        >
          <div className="profile_page_modern_v2">
                      <div className="profile_card_main_box">
                        {/* Upper Banner Section */}
                        <div
                          className="profile_banner_section"
                          style={{ backgroundImage: `url('/images/backimage.jpg')`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                        >
                          <div className="banner_overlay_shade"></div>
          
                          {/* Avatar Section - Floating Style */}
                          <div className="avatar_upload_container">
                            <label className="avatar_label_modern">
                              <input
                                className="d-none"
                                type="file"
                                onChange={(e) => Result(e.target.files[0])}
                                accept="image/*"
                                required
                              />
                              <div className="avatar_frame_premium">
                                {profile1 && profile1.avatar ? (
                                  <img
                                    className="user_img_fluid"
                                    src={baseUrl + `/${profile1.avatar}`}
                                    alt="Avatar"
                                  />
                                ) : (
                                  <img
                                    className="user_img_fluid"
                                    src={process.env.PUBLIC_URL + `/user.png`}
                                    alt="Default"
                                  />
                                )}
                                <div className="camera_badge">
                                  <i className="fa fa-camera"></i>
                                </div>
                              </div>
                            </label>
                          </div>
                        </div>
          
                        {/* Info Content Section */}
                        <div className="profile_content_body">
          
                          {/* User Name Area */}
                          <div className="info_block_premium">
                            <div className="field_label_group">
                              <span className="tiny_label">Display Name</span>
                              <h2 className="main_name_display">
                                {profile && profile.Name}
                                <img
                                  className="edit_trigger_icon"
                                  src={process.env.PUBLIC_URL + "/images/icon-edit.jpg"}
                                  alt="edit"
                                  onClick={() => {
                                    setPortcss(css.inactive_tab);
                                    setPortcss1(css.active_tab);
                                  }}
                                />
                              </h2>
                            </div>
          
                            {/* Edit Name Field Logic */}
                            <div className={`modern_edit_field_wrap ${portcss1}`}>
                              <div className="modern_input_box_wrapper">
                                <input
                                  type="text"
                                  maxLength={"20"}
                                  placeholder="Enter Username"
                                  value={Name}
                                  onChange={(e) => setName(e.target.value)}
                                />
                                <img
                                  src={process.env.PUBLIC_URL + "/images/select-blue-checkIcon.png"}
                                  alt="save"
                                  className="save_action_icon"
                                  onClick={() => {
                                    setPortcss(css.active_tab);
                                    setPortcss1(css.inactive_tab);
                                    UpdateProfile(Id);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
          
                          {/* Phone Area */}
                          <div className="info_block_premium">
                            <div className="field_label_group">
                              <span className="tiny_label">Phone Number</span>
                              <div className="icon_value_row">
                                <IoIosCall className="row_icon_modern" />
                                <h3 className="row_value_text">{profile && profile?.Phone}</h3>
                              </div>
                            </div>
                          </div>
          
                          {/* Email Area */}
                          <div className="info_block_premium">
                            <div className="field_label_group">
                              <span className="tiny_label">Email Address</span>
                              <div className="email_row_flex">
                                <div className="icon_value_row">
                                  <HiOutlineMail className="row_icon_modern" />
                                  {profile?.Email === null ? (
                                    <span className="unverified_status">Verify your Email</span>
                                  ) : (
                                    <h3 className="row_value_text">{profile?.Email}</h3>
                                  )}
                                </div>
                                <img
                                  className="edit_trigger_icon"
                                  src="/images/icon-edit.jpg"
                                  alt="edit"
                                  onClick={toggleInput}
                                />
                              </div>
                            </div>
          
                            {/* Email Edit Input Logic */}
                            {inputOpen && (
                              <div className="modern_edit_field_wrap active_tab">
                                <div className="modern_input_box_wrapper">
                                  <input
                                    type="email"
                                    placeholder="Enter your email"
                                    value={Email}
                                    onChange={handleEmailChange}
                                  />
                                  <img
                                    src="/images/select-blue-checkIcon1.png"
                                    alt="save"
                                    className="save_action_icon"
                                    onClick={() => {
                                      toggleInput();
                                      if (isValidEmail) {
                                        UpdateEmail(Id);
                                      } else {
                                        Swal.fire({
                                          title: "Please enter your email",
                                          icon: "error",
                                          confirmButtonText: "OK",
                                        });
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                          {/* MODEL OF KYC  */}
                          <Modal
                            show={showKyc}
                            onHide={handleCloseKyc}
                            className=" kyc_popup"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                          >
                            <ul
                              className="nav nav-tabs mb-2"
                              id="myTab"
                              role="tablist"
                              style={{ justifyContent: "center" }}
                            >
                              {
                                addCaseSetting?.onlineKYC
                                &&
                                <li className="nav-item mr-2" role="presentation">
                                  <button
                                    className="nav-link active tabs"
                                    id="informative-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#informative"
                                    type="button"
                                    role="tab"
                                    aria-controls="informative"
                                    aria-selected="true"
                                  >
                                    Online KYC
                                  </button>
                                </li>
                              }
                              {
                                addCaseSetting?.offlineKYC
                                &&
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link "
                                    id="game-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#game"
                                    type="button"
                                    role="tab"
                                    aria-controls="game"
                                    aria-selected="true"
                                  >
                                    Offline KYC
                                  </button>
                                </li>
                              }
                            </ul>
                            <div className="tab-content" id="myTabContent">
                              {
                                addCaseSetting?.onlineKYC
                                &&
                                <div
                                  className="tab-pane fade show active"
                                  id="informative"
                                  role="tabpanel"
                                  aria-labelledby="informative-tab"
                                >
                                  <div className="input-group input-group-sm mb-2 ">
                                    <label className="commaon_label">
                                      Enter your Aadhar Number
                                    </label>
                                    <input
                                      type="number"
                                      className="commaon_input_box border border"
                                      aria-describedby="basic-addon1"
                                      value={AadharNum}
                                      placeholder="Aadhar Number"
                                      onChange={handleAdharChnage}
                                    />
                                  </div>
                                  <div className="input-group input-group-sm mb-2 ">
          
                                    <label className="commaon_label">
                                      Enter your Email
                                    </label>
                                    <input
                                      type="email"
                                      className="commaon_input_box border border"
                                      aria-describedby="basic-addon1"
                                      value={Email}
                                      placeholder="Enter Email"
                                      onChange={handleEmailChange}
                                    />
                                    <h5 className="mt-2" style={{ color: "red" }}>{msg}</h5>
                                    {isLoading ? (
                                      <div
                                        className="pl-2 text-center d-flex"
                                        style={{
                                          justifyContent: "center",
                                          width: "100%",
                                          marginTop: "10px",
                                        }}
                                      >
                                        <img
                                          src={findGif}
                                          style={{
                                            width: "50px",
                                            height: "50px",
                                            margin: "auto",
                                          }}
                                        />
                                      </div>
                                    ) : !userAdharData?.status === true || userAdharData.data?.status === "error" ? (
                                      <div className="text-center">
          
                                        <button
                                          onClick={AdharNumber}
                                          className="profile_wallet mt-2"
                                        >
                                          Send OTP
                                        </button>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  {userAdharData?.status === true && userAdharData.data?.data?.otp_sent === true ? (
                                    <div className="input-group input-group-sm mb-2">
                                      <label className="commaon_label">Enter OTP</label>
                                      <input
                                        type="number"
                                        className="commaon_input_box border"
                                        aria-describedby="basic-addon1"
                                        value={AadharOtp}
                                        onChange={handleAdharOtpChnage}
                                      />
          
                                      {isLoading1 ? (
                                        <div
                                          className="pl-2 text-center d-flex"
                                          style={{
                                            justifyContent: "center",
                                            width: "100%",
                                            marginTop: "10px",
                                          }}
                                        >
                                          <img
                                            src={findGif}
                                            style={{ width: "50px", height: "50px" }}
                                            alt="Loading..."
                                          />
                                        </div>
                                      ) : (
                                        <div className="text-center">
                                          <button
                                            onClick={AdharOtp}
                                            className={`profile_wallet mt-2 ${isLoading1 ? "loading" : ""
                                              }`}
                                            disabled={isLoading1}
                                          >
                                            Submit OTP
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    " "
                                  )}
                                </div>
                              }
                              {
                                addCaseSetting.offlineKYC
                                &&
                                <div
                                  className={`tab-pane fade ${!addCaseSetting.onlineKYC && addCaseSetting.offlineKYC ? 'show active' : ''}`}
                                  id="game"
                                  role="tabpanel"
                                  aria-labelledby="game-tab"
                                >
                                  <div class="input-group input-group-sm mb-2">
                                    <label className="commaon_label">Enter Name</label>
                                    <input
                                      type="text"
                                      class="commaon_input_box border"
                                      value={Names}
                                      onChange={(e) => setNames(e.target.value)}
                                      aria-label="Sizing example input"
                                      aria-describedby="inputGroup-sizing-sm"
                                    />
                                  </div>
                                  <div class="input-group input-group-sm mb-2">
                                    <label className="commaon_label">
                                      Enter Aadhar Number
                                    </label>
                                    <input
                                      type="text"
                                      class="commaon_input_box border"
                                      value={AadharNum}
                                      onChange={handleAdharChnage}
                                      aria-label="Sizing example input"
                                      aria-describedby="inputGroup-sizing-sm"
                                    />
                                  </div>
                                  <div class="input-group input-group-sm mb-2">
                                    <label className="commaon_label">
                                      Enter your Email
                                    </label>
                                    <input
                                      type="email"
                                      class="commaon_input_box border"
                                      value={Email}
                                      onChange={handleEmailChange}
                                      aria-label="Sizing example input"
                                      aria-describedby="inputGroup-sizing-sm"
                                    />
                                  </div>
                                  <div class="input-group input-group-sm mb-2">
                                    <label className="commaon_label">Enter DOB</label>
                                    <input
                                      type="date"
                                      class="commaon_input_box border"
                                      value={DOB}
                                      onChange={(e) => setDob(e.target.value)}
                                      aria-label="Sizing example input"
                                      aria-describedby="inputGroup-sizing-sm"
                                    />
                                  </div>
                                  <div class="input-group input-group-sm mb-2">
                                    <label className="commaon_label">Front Image</label>
                                    <input
                                      class="commaon_input_box border"
                                      id="frontPhoto"
                                      name="frontPhoto"
                                      type="file"
                                      onChange={(e) => setFrontLoaded(e.target.files)}
                                      accept="image/*"
                                      required
                                      aria-label="Sizing example input"
                                      aria-describedby="inputGroup-sizing-sm"
                                    />
                                  </div>
          
                                  <div class="input-group input-group-sm mb-2">
                                    <label className="commaon_label">Back Image</label>
                                    <input
                                      id="backPhoto"
                                      name="backPhoto"
                                      type="file"
                                      accept="image/*"
                                      onChange={(e) => setBackLoaded(e.target.files)}
                                      class="commaon_input_box border"
                                      aria-label="Sizing example input"
                                      aria-describedby="inputGroup-sizing-sm"
                                      required
                                    />
                                  </div>
                                  <div className="text-center">
                                    <button
                                      className="profile_wallet mt-2 mb-2"
                                      onClick={handleSubmitdata}
                                    >
                                      submit
                                    </button>
                                  </div>
                                </div>
                              }
                            </div>
          
                            <Modal.Footer>
                              <Button variant="secondary" onClick={handleCloseKyc}>
                                Close
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        </div>
                      </div>
                    </div>
          
                    <div className="action_container_modern">
                      <div className="action_row_flex">
          
                        {/* KYC TILE - Dynamic Colors based on status */}
                        <div
                          className={`modern_tile ${profile?.verified === "verified" ? "verified_bg" : profile?.verified === "reject" ? "reject_bg" : "pending_bg"}`}
                          onClick={profile?.verified === "verified" ? handleShowBottom : Kyc}
                        >
                          <div className="tile_icon_box">
                            <img src="/images/kyc-icon-new.png" alt="KYC" />
                          </div>
                          <div className="tile_text_box">
                            <label>KYC Status</label>
                            {profile && profile.verified === "verified" ? (
                              <h4 className="status_msg">Verified ✅</h4>
                            ) : profile && profile.verified === "pending" ? (
                              <h4 className="status_msg">In Process ⌚</h4>
                            ) : (
                              <h4 className="status_msg">
                                {profile && profile.verified === "reject" ? "Rejected ❌" : "Verify Now"}
                              </h4>
                            )}
                          </div>
                          <div className="action_chevron">
                            <i className="fa-solid fa-chevron-right"></i>
                          </div>
                        </div>
          
                        {/* WALLET TILE */}
                        <Link to="/Addcase" className="modern_tile wallet_bg">
                          <div className="tile_icon_box">
                            <img src={process.env.PUBLIC_URL + "/images/icons/wallett.png"} alt="Wallet" />
                          </div>
                          <div className="tile_text_box">
                            <label>Balance</label>
                            <h4 className="status_msg">My Wallet</h4>
                          </div>
                          <div className="action_chevron">
                            <i className="fa-solid fa-chevron-right"></i>
                          </div>
                        </Link>
          
                      </div>
                    </div>
          
                    
          
                    {profile && !profile.referral && (
                      <div className="refer_unlocker_wrapper">
                        <div className="unlocker_card">
                          <div className="unlocker_header">
                            <div className="gift_icon_box">
                              <i className="fa-solid fa-gift"></i>
                            </div>
                            <div className="unlocker_title_box">
                              <h3>Unlock Bonus</h3>
                              <p className="mb-0">Enter a referral code to get rewards</p>
                            </div>
                          </div>
          
                          <div className="modern_action_field">
                            <input
                              type="text"
                              className="premium_code_input"
                              value={referral}
                              onChange={(e) => {
                                setCode(e.target.value);
                              }}
                              placeholder="ENTER REFER CODE"
                            />
                            <button
                              className="submit_code_btn"
                              onClick={() => {
                                update_RefCode();
                              }}
                            >
                              <img
                                src="/images/select-blue-checkIcon.png"
                                alt="Apply"
                              />
                              <span>Apply</span>
                            </button>
                          </div>
          
                          {/* Visual background element */}
                          <div className="card_accent_glow"></div>
                        </div>
                      </div>
                    )}
                    {/* cash won small box */}
                    <div className="other_details_modern_wrap">
                      <h2 className="section_title_new">Account Statistics</h2>
          
                      <div className="stats_glass_grid">
                        {/* Coin Won */}
                        <div className="stat_glass_card">
                          <div className="stat_glow_bg bg_gold"></div>
                          <div className="stat_icon_box">
                            <img src="/images/icons/money.png" alt="money" />
                          </div>
                          <div className="stat_content">
                            <p>Coin Won</p>
                            <h3>₹{profile && profile.wonAmount}</h3>
                          </div>
                        </div>
          
                        {/* Battle Played */}
                        <div className="stat_glass_card">
                          <div className="stat_glow_bg bg_pink"></div>
                          <div className="stat_icon_box">
                            <img src="/images/battle.png" alt="battle" />
                          </div>
                          <div className="stat_content">
                            <p>Battles</p>
                            {/* <h3>{total && total}</h3> */}
                            <h3>0</h3>
                          </div>
                        </div>
          
                        {/* Referral */}
                        <div className="stat_glass_card">
                          <div className="stat_glow_bg bg_blue"></div>
                          <div className="stat_icon_box">
                            <img src="/images/LandingPage_img/notification-activity-reward.png" alt="refer" />
                          </div>
                          <div className="stat_content">
                            <p>Referral</p>
                            <h3>₹{profile && profile.referral_earning}</h3>
                          </div>
                        </div>
                      </div>
          
                      {/* New Premium Logout Button */}
                      <div className="logout_section_new mt-5">
                        <Link
                          to="/login"
                          className="modern_logout_btn_v3"
                          onClick={(e) => logout(e)}
                        >
                          <div className="logout_btn_inner">
                            <i className="fa-solid fa-power-off"></i>
                            <span>LOGOUT ACCOUNT</span>
                          </div>
                          <div className="logout_btn_shine"></div>
                        </Link>
                      </div>
                    </div>
        </div>
      }

      <div className="rightContainer">
        <Rightcontainer />
      </div>
      {/* <ModalProfile style3={
                profileModalstyle
            } Enter={Enter}/> */}
      <div className={css.kyc_select} id="profileModal">
        <div className={css.overlay} />
        <div
          className={`${css.box}`}
          style={{
            bottom: "0px",
            position: "absolute",
          }}
        >
          <div className={css.bg_white}>
            <div className={`${css.header} ${css.cxy} ${css.flex_column}`}>
              <picture>
                <img
                  height="80px"
                  width="80px"
                  src="/images/avatars/Avatar2.png"
                  alt=""
                />
              </picture>
              <div className={`${css.header_text} mt-2`}>Choose Avatar</div>
            </div>
            <div className="mx-3 pb-3" style={{ paddingTop: "200px" }}>
              <div className="row justify-content-between col-10 mx-auto">
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar1.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar2.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar3.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar4.png"
                  alt=""
                />
              </div>
              <div className="row justify-content-between col-10 mx-auto mt-3">
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar5.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar6.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar7.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar8.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Profile1;
